import { style, keyframes } from '@vanilla-extract/css'

const slide = keyframes({
  '0%': { transform: 'translateX(0)' },
  '100%': { transform: 'translateX(calc(-320px * 6))' },
})

export const carousel = style({
  overflowX: 'hidden',
	position: 'relative',
})

export const images = style({
  display: 'flex',
  animationName: slide,
  animationDuration: '20s',
  animationIterationCount: 'infinite',
  animationTimingFunction: 'linear',
})

export const image = style({
  width: '296px',
  height: '370px',
  borderRadius: '16px',
  marginRight: '24px',
})
